LabelsView = require 'app/scripts/views/label/labels-view'
PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'

module.exports = class CardLabelSelectView extends View
  viewTitleKey: 'labels'

  el: ->
    @labelsView = @subview LabelsView, @model,
      board: @model.getBoard()
      selectLabel: @toggleLabel.bind(@)
      renderOn: [
        { source: @model.labelList, events: 'add remove reset change' }
        { source: @model, events: 'change:labels, change:idLabels' }
      ]
      popOverMethod: 'pushView'
      searchInit: @options.searchInit

    @labelsView.render().el

  toggleLabel: (idLabel, fromSuggestion) ->
    @model.toggleLabel(@modelCache.get('Label', idLabel))
    if @options.hideOnSelect
      PopOver.popView()
    return
